import React, { useEffect, useState } from "react";
import "./App.css";

import { cardImages } from "./ImageData/ImageData";
import Card from "./Card/Card";

const Header = ({ handleRestart, handleStart, time, fastestTime }) => {
  return (
    <>
      <div className="game-header">
        <p className="creator-credit">Created By AzoreDev{"</>"}</p>{" "}
        <h1 className="game-title">Cosmic Match Quest</h1>
        <div className="game-stats">
          <p>
            Current Journey Time:{" "}
            <span className="current-time">{time} seconds</span>
          </p>
          <p>
            Fastest Expedition:{" "}
            <span className="fastest-time">
              {fastestTime !== null
                ? `${fastestTime} seconds`
                : "Awaits Discovery"}
            </span>
          </p>
        </div>
        <div>
          <button onClick={handleStart}>Launch Game</button>
          <button onClick={handleRestart}>Reset Universe</button>
        </div>
      </div>
    </>
  );
};

function App() {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [fastestTime, setFastestTime] = useState(null);
  const [cards, setCards] = useState([]);
  const [completed, setCompleted] = useState(false);

  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const handleChoice = (card) => {
    if (isRunning && !disabled && !completed) {
      if (choiceOne && card.id === choiceOne.id) {
        return;
      }
      choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
    }
  };

  function resetChoices() {
    setChoiceOne(null);
    setChoiceTwo(null);
    setDisabled(false);
  }

  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.src === choiceTwo.src) {
        setCards((prevCards) => {
          return prevCards.map((card) => {
            if (card.src === choiceOne.src) {
              return { ...card, matched: true };
            } else {
              return card;
            }
          });
        });
        resetChoices();
      } else {
        setTimeout(() => resetChoices(), 1000);
      }
    }
  }, [choiceOne, choiceTwo]);

  useEffect(() => {
    if (cards.length > 0 && cards.every((card) => card.matched)) {
      setIsRunning(false);
      setCompleted(true);
      if (fastestTime === null || time < fastestTime) {
        setFastestTime(time);
      }
    } else {
      setCompleted(false);
    }
  }, [cards, time, fastestTime]);

  const shuffleCards = () => {
    const shuffledCards = [...cardImages, ...cardImages]
      .sort(() => Math.random() - 0.5)
      .map((card) => ({ ...card, id: Math.random(), matched: false }));
    setCards(shuffledCards);
    setTime(0);
    setIsRunning(false);
    setCompleted(false);
    resetChoices();
  };

  useEffect(() => {
    shuffleCards();
  }, []);

  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning]);

  const handleStart = () => {
    if (!isRunning && cards.length > 0 && !completed) {
      setIsRunning(true);
    } else if (completed) {
      handleRestart();
    }
  };

  const handleRestart = () => {
    if (completed && (fastestTime === null || time < fastestTime)) {
      setFastestTime(time);
    }
    shuffleCards();
  };

  return (
    <div className="App">
      <div className="moving-background">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <Header
        handleRestart={handleRestart}
        handleStart={handleStart}
        time={time}
        fastestTime={fastestTime}
      />

      <div className="card-grid-container">
        {" "}
        {completed && (
          <div className="completion-message">
            <h2>Quest Completed!</h2>
            <p>
              Your journey took {fastestTime !== null ? fastestTime : time}{" "}
              seconds!
            </p>
          </div>
        )}
        <div className={`card-grid ${completed ? "fade-out" : ""}`}>
          {" "}
          {cards.map((card) => (
            <Card
              key={card.id}
              card={card}
              handleChoice={handleChoice}
              flipped={card === choiceOne || card === choiceTwo || card.matched}
              disabled={disabled || completed}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
